import { useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import { Button, useToast } from "../../ui";

/** Отмена неоплаченного абонемента (админ). */
export default function CancelPendingMembershipButton({
  membership,
  onSuccess,
  size = "sm",
}) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  if (!membership || membership.status !== "pending") return null;

  const cancel = async () => {
    if (
      !window.confirm(
        "Отменить неоплаченный абонемент? Клиент сможет оформить заказ заново.",
      )
    ) {
      return;
    }
    setBusy(true);
    try {
      const res = await clinicAPI.cancelClientMembership(membership.id);
      if (res.status === "confirmed") {
        toast.success(
          res.message || "Оплата уже прошла — абонемент активирован",
        );
      } else {
        toast.success("Абонемент отменён");
      }
      onSuccess?.(res);
    } catch (err) {
      toast.error(err.response?.data?.error || "Не удалось отменить");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      size={size}
      variant="secondary"
      disabled={busy}
      onClick={cancel}
    >
      {busy ? "…" : "Отменить"}
    </Button>
  );
}
